import {useLocalStorageState} from '@coolcolduk/ui-common-hook';
import {useEffect, useState} from 'react';
import {UserAccount} from '../__generated__/resolvers-types';
import useGetAllAccountToken from './useGetAllAccountToken';

export default function useEtsyAccountLinkDialog(user: UserAccount | null | undefined) {
  const [showDialog, setShowDialog] = useState(false);
  const [hasShownDialog, setHasShownDialog] = useLocalStorageState('hasShownDialog', false);
  const {accounts, refetchAccounts, loading} = useGetAllAccountToken();

  useEffect(() => {
    refetchAccounts();
  }, [user, refetchAccounts]);

  // Check if user should see the dialog
  useEffect(() => {
    // CRITICAL: Only show dialog when user has NO linked Etsy accounts
    // Only show dialog if:
    // 1. User is authenticated
    // 2. User has no Etsy accounts linked (accounts.length === 0)
    // 3. Dialog hasn't been shown yet
    // 4. Accounts are not currently loading (prevents flash)
    if (user && accounts.length === 0 && !hasShownDialog && !loading) {
      setShowDialog(true);
      setHasShownDialog(true);
    }

    // Hide dialog if user has accounts (in case accounts are added while dialog is open)
    if (accounts.length > 0 && showDialog) {
      setShowDialog(false);
    }
  }, [user, accounts, hasShownDialog, showDialog, loading, refetchAccounts, setHasShownDialog]);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleAccountLinked = () => {
    // Refetch accounts to update the state
    refetchAccounts();
  };

  return {
    showDialog,
    handleCloseDialog,
    handleAccountLinked,
  };
}
